/* QISSA — lightweight interactions. No dependencies. */
(function () {
  var root = document.documentElement;

  /* Reveal on scroll */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-q-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Header: transparent over hero, solid after scroll */
  function initHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var setH = function () {
      var h = header.getBoundingClientRect().height;
      if (h) root.style.setProperty('--q-header-h', h + 'px');
    };
    setH();
    window.addEventListener('resize', setH, { passive: true });
    if (!document.body.classList.contains('template-index')) { header.classList.add('q-solid'); return; }
    var ticking = false;
    var update = function () {
      header.classList.toggle('q-solid', window.scrollY > 40);
      ticking = false;
    };
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* Hero: mark loaded for entrance motion */
  function initHero() {
    document.querySelectorAll('.q-hero').forEach(function (hero) {
      var img = hero.querySelector('img');
      var go = function () { hero.classList.add('is-loaded'); };
      if (!img || img.complete) { requestAnimationFrame(go); } else { img.addEventListener('load', go, { once: true }); setTimeout(go, 1200); }
    });
  }

  /* Cart drawer: show "Scene added to your story." only after an add-to-bag */
  function initAdded() {
    var justAdded = false;
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-form')) justAdded = true;
    }, true);
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      var msg = drawer.querySelector('.q-added');
      if (!msg) return;
      if (drawer.classList.contains('active') && justAdded) {
        msg.classList.add('is-on'); justAdded = false;
        setTimeout(function () { msg.classList.remove('is-on'); }, 5000);
      } else if (!drawer.classList.contains('active')) { msg.classList.remove('is-on'); }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() { initReveal(); initHeader(); initHero(); initAdded(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initHero(); });
})();
